<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-compare-capgo-hero-section id="hero"></app-compare-capgo-hero-section>
  <!-- Customer Logos -->
  <app-customer-logo-section id="customers"></app-customer-logo-section>
  <!-- Key Advantages -->
  <app-compare-capgo-advantages-section
    id="advantages"
  ></app-compare-capgo-advantages-section>
  <!-- Comparison Table -->
  <app-compare-capgo-table-section
    id="comparison"
  ></app-compare-capgo-table-section>
  <!-- Testimonials -->
  <app-testimonials-section id="testimonials" [testimonials]="testimonials">
    <div slot="header">
      <app-section-header
        [description]="
          'See why teams are switching from Capgo to Capawesome Cloud'
        "
        [icon]="'@tui.heart'"
        [subtitle]="'Customer Stories'"
        [title]="'Why teams choose Capawesome Cloud over Capgo'"
      ></app-section-header>
    </div>
  </app-testimonials-section>
  <!-- FAQ -->
  <app-compare-capgo-faq-section id="faq"></app-compare-capgo-faq-section>
  <!-- CTA -->
  <app-cta-section id="cta"></app-cta-section>
</div>
